import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconArchiveComponent } from './icon-archive.component';



@NgModule({
  declarations: [IconArchiveComponent],
  exports: [
    IconArchiveComponent
  ],
  imports: [
    CommonModule
  ]
})
export class IconArchiveModule { }
